const AUSTRALIA_BANK_NUMBER_FORMAT = '999999';

export { AUSTRALIA_BANK_NUMBER_FORMAT };
